import React, { useReducer } from 'react';

const initialInputState = {
  value: '',
  isTouched: false,
};

enum InputActionType {
  INPUT = 'INPUT',
  BLUR = 'BLUR',
  RESET = 'RESET',
}

interface InputAction {
  type: InputActionType;
  value?: string;
}

interface InputState {
  value: string;
  isTouched: boolean;
}

const inputStateReducer = (state: InputState, action: InputAction): any => {
  switch (action.type){
    case 'INPUT':
      return { ...state, value: action.value };
    case 'BLUR':
      return { ...state, isTouched: true };
    case 'RESET':
      return initialInputState;
  }
  return initialInputState;
};

const useInput = (validateValue: any): any => {
  const [inputState, dispatch] = useReducer(inputStateReducer, initialInputState);

  const valueIsValid = validateValue(inputState.value);
  const hasError = !valueIsValid && inputState.isTouched;

  const valueChangeHandler = (event: React.FormEvent<HTMLInputElement>): void => {
    dispatch({ type: InputActionType.INPUT, value: event.currentTarget.value });
  };

  const inputBlurHandler = (): void => {
    dispatch({ type: InputActionType.BLUR });
  };

  const reset = (): void => {
    dispatch({ type: InputActionType.RESET });
  };

  const valueSetHandler = (value: string): void => {
    dispatch({ type: InputActionType.INPUT, value: value });
  };

  return {
    value: inputState.value,
    isValid: valueIsValid,
    hasError: hasError,
    valueChangeHandler: valueChangeHandler,
    valueSetHandler: valueSetHandler,
    inputBlurHandler: inputBlurHandler,
    reset: reset,
  };
};

export default useInput;
